export default "__VITE_ASSET__CVEYbNgN__"